import React from 'react'
import {Card, CardBody, Col, Row} from 'reactstrap'
import PackingStatistics from "./PackingStatistics"
import OvertimedStatistics from './OvertimedStatistics'


class StatisticsView extends React.Component {
    render() {
        const {statistics} = this.props;
        const {notPrinted, notPacked, inProcessing} = statistics;

        return (
            <div className='StatisticsView'>
                <div className="page-title">
                    <h1 className="mb-0 font-weight-black">Hệ thống quản trị KTS Bình Minh</h1>
                </div>
                <Row className='text-center'>
                    <Col md={6} className="Left">
                        <Row>
                            <Col md={4}>
                                <Card>
                                    <div className="card-header bg-warning text-white header-elements-inline">
                                        <h2 className="card-title"><i className="icon-printer"/> Chờ in</h2>
                                    </div>
                                    <CardBody>
                                        <h3 className='font-weight-semibold mb-0'>{notPrinted}</h3>
                                        <span className="text-muted font-size-sm">Số áo đang chờ in trong ngày</span>
                                    </CardBody>
                                </Card>
                            </Col>
                            <Col md={4}>
                                <Card>
                                    <div className="card-header bg-warning text-white header-elements-inline">
                                        <h2 className="card-title"><i className="icon-truck"/> Chờ đóng gói</h2>
                                    </div>
                                    <CardBody>
                                        <h3 className='font-weight-semibold mb-0'>{notPacked}</h3>
                                        <span className="text-muted font-size-sm">Số đơn đang chờ đóng gói trong ngày</span>
                                    </CardBody>
                                </Card>
                            </Col>
                            <Col md={4}>
                                <Card>
                                    <div className="card-header bg-warning text-white header-elements-inline">
                                        <h2 className="card-title"><i className="icon-file-text"/> Order chờ xử lý</h2>
                                    </div>
                                    <CardBody>
                                        <h3 className='font-weight-semibold mb-0'>{inProcessing}</h3>
                                        <span className="text-muted font-size-sm">Số đơn hàng chờ đẩy xưởng</span>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>

                        <OvertimedStatistics/>
                    </Col>

                    <Col md={6} className="Right">
                        <PackingStatistics/>
                    </Col>
                </Row>
            </div>
        )
    }
}

export default StatisticsView
